import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import _ from 'lodash';
import { ToastPackage, ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import {
   AcceptNewOutboundCallRequest,
   CloseOpenConfirmOutboundCallNotifications,
} from 'src/app/store/notification/notification-toastr/notification-toastr.actions';
import { DirectoriesService } from 'src/generated/swagger';
import { CallingToastBaseComponent } from '../calling-toast-base/calling-toast.base.component';

@Component({
   selector: 'samweb-outbound-confirmation-toast',
   templateUrl: './outbound-confirmation-toast.component.html',
   styleUrls: ['./outbound-confirmation-toast.component.scss'],
})
export class OutboundConfirmationToastComponent extends CallingToastBaseComponent {
   public outboundCallNotificationTitle$: Observable<any> = this.getOutboundCallNotificationTitle$(this.message);

   constructor(
      toastrService: ToastrService,
      toastPackage: ToastPackage,
      store: Store,
      private translationService: TranslateService,
      private directoriesService: DirectoriesService
   ) {
      super(toastrService, toastPackage, store);
   }

   cancelCall() {
      this.store.dispatch(new CloseOpenConfirmOutboundCallNotifications(this.toastPackage.toastId));
   }

   confirmCall() {
      this.store.dispatch(new AcceptNewOutboundCallRequest(this.toastPackage.toastId));
      this.store.dispatch(new CloseOpenConfirmOutboundCallNotifications(this.toastPackage.toastId));
   }

   getOutboundCallNotificationTitle$(numberToDial: string): Observable<any> {
      return this.directoriesService.reverseNameLookup(numberToDial).pipe(
         switchMap((nameLookupResponse) => {
            const subscriberName = _.trim(nameLookupResponse.name);
            return this.translationService.get('notification.request_new_call.title', {
               contact: _.isEmpty(subscriberName) ? numberToDial : subscriberName,
            });
         })
      );
   }
}
